import { ArrowRight, Plus, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { formatRelative } from '@/lib/utils';

interface ActivityItem {
  id: string;
  type: 'stage_change' | 'deal_created' | 'deal_closed' | 'note_added';
  description: string;
  dealTitle: string;
  userName: string;
  createdAt: string;
}

export function ActivityFeed() {
  // Placeholder - will be wired to trpc.dashboard.activityFeed with cursor pagination
  const activities: ActivityItem[] = [];
  const hasMore = false;

  const getIcon = (type: ActivityItem['type']) => {
    switch (type) {
      case 'stage_change':
        return <ArrowRight className="h-4 w-4 text-blue-500" />;
      case 'deal_created':
        return <Plus className="h-4 w-4 text-green-500" />;
      case 'deal_closed':
        return <RefreshCw className="h-4 w-4 text-purple-500" />;
      case 'note_added':
        return <RefreshCw className="h-4 w-4 text-gray-500" />;
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {activities.length === 0 ? (
          <div className="py-8 text-center text-sm text-muted-foreground">
            No recent activity. Start by creating your first deal.
          </div>
        ) : (
          <div className="space-y-4">
            {activities.map((activity) => (
              <div key={activity.id} className="flex items-start gap-3">
                <div className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted">
                  {getIcon(activity.type)}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm">
                    <span className="font-medium">{activity.userName}</span>{' '}
                    {activity.description}{' '}
                    <span className="font-medium">{activity.dealTitle}</span>
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {formatRelative(activity.createdAt)}
                  </p>
                </div>
              </div>
            ))}

            {hasMore && (
              <Button variant="ghost" size="sm" className="w-full">
                Load more
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
